import React from 'react';
import { observer } from 'mobx-react-lite';
import generatedHooks from '../hooks/generatedHooks';

const { useUiStore } = generatedHooks;

const wrapInObserver = (ComponentToWrap, propsMapper, MobileComponentToWrap = null) =>
  observer((props) => {
    const { isMobile } = useUiStore(store => store);
    const Component = isMobile && MobileComponentToWrap ? MobileComponentToWrap : ComponentToWrap;
    return <Component {...propsMapper(props)} />;
  });

export default wrapInObserver;
